module.exports = __webpack_public_path__ + "static/media/nasa-logo.63e40655.png";